import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const coachNeeds = ['More structure.', 'More clarity.', 'Better progressions.', 'A faster way to turn knowledge into coaching.'];
const beforeItems = ['Searching for drills.', 'Saving random videos.', 'Repeating familiar exercises.', 'Building progressions manually.', 'Trying to connect phases.', 'Planning after hours.'];
const withItems = ['Choose the objective.', 'Open the visual system.', 'Set the drill.', 'Follow the progression.', 'Correct the athlete.', 'Coach.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-zinc-900 border-y border-zinc-800" data-id="element-47" data-mp="18m5tmizyzhkh">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-4xl mx-auto text-center" data-id="element-48" data-mp="13nvtrv3avssj">
        <h2 className="text-3xl md:text-4xl font-black uppercase text-white mb-6" data-id="element-49" data-mp="24vl8uyr7n4jh">
          MMA coaches don&apos;t need more random information.
        </h2>
        <p className="text-xl text-zinc-300 mb-3" data-id="element-50" data-mp="28wohb06xhyao">They need:</p>
        <ul className="space-y-1 mb-10" data-id="element-51" data-mp="1v6l38wi7dawb">
          {coachNeeds.map(need => <li key={need} className="text-xl md:text-2xl font-display font-black uppercase text-amber-400" data-id="element-52" data-mp="204mo9mz6vkaf">
              {need}
            </li>)}
        </ul>

        <div className="bg-zinc-950 border border-zinc-800 rounded-2xl p-8 text-lg text-zinc-400 space-y-2 max-w-3xl mx-auto" data-id="element-53" data-mp="1l9yl4fh9gxxz">
          <p data-id="element-54" data-mp="1c778wdgk9y5a">
            With MMA Coach Ready, you do not have to begin every session from an empty page.
          </p>
          <p className="text-white font-semibold" data-id="element-55" data-mp="1h71wo851i7m4">You already have the framework.</p>
          <p className="text-white font-semibold" data-id="element-56" data-mp="36kf8eifhexx9">You already have the progression.</p>
          <p className="text-white font-semibold" data-id="element-57" data-mp="3bjrq6orhxesz">You already have the visual coaching tools.</p>
          <p className="text-white font-semibold" data-id="element-58" data-mp="3954t43i0f6q9">
            And with 150 ready-to-coach sessions, you already have the session.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mt-12 text-left" data-id="element-59" data-mp="352hu9imx8ljk">
          <div className="bg-zinc-950 border border-zinc-800 rounded-2xl p-6 md:p-8" data-id="element-60" data-mp="305rgx32i441u">
            <h3 className="text-lg font-extrabold uppercase text-zinc-500 mb-5" data-id="element-61" data-mp="2v6eugjfjkyzs">
              Before MMA Coach Ready
            </h3>
            <ul className="space-y-3" data-id="element-62" data-mp="3ssue9rvfy8qi">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-63" data-mp="3nvlslhb33mki">
                  <X size={18} className="text-zinc-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-64" data-mp="3j310ck7tthj3" />
                  <span className="text-zinc-500" data-id="element-65" data-mp="3e4r2g1upw2ts">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-zinc-950 border-2 border-amber-400/80 rounded-2xl p-6 md:p-8" data-id="element-66" data-mp="ffit3yu4l479">
            <h3 className="text-lg font-extrabold uppercase text-amber-400 mb-5" data-id="element-67" data-mp="ampqphm4q7yc">With MMA Coach Ready</h3>
            <ul className="space-y-3" data-id="element-68" data-mp="hzyo7xfit7v3">
              {withItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-69" data-mp="mx6zrf65ydnd">
                  <Check size={18} className="text-amber-400 shrink-0 mt-0.5" aria-hidden="true" data-id="element-70" data-mp="rx32lb34jz1c" />
                  <span className="text-white font-medium" data-id="element-71" data-mp="ww696zyr6dbf">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="text-3xl md:text-4xl font-display font-black uppercase text-white mt-12" data-id="element-72" data-mp="10wzynxrug06f">
          Less planning. <span className="text-red-500" data-id="element-73" data-mp="15v9qbyed0ina">More coaching.</span>
        </p>
      </motion.div>
    </section>;
}